import React, { useState } from "react";
import {
  Box,
  makeStyles,
  Typography,
  Button,
  Grid,
  Input,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  dottedBox: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "1.3rem",
  },
  dot: {
    backgroundColor: "#1ed059",
    height: "10px",
    width: "3px",
    borderRadius: "57px",
    margin: "3px 0px",
  },
  inActiveDot: {
    backgroundColor: "#D4D4D4",
    height: "10px",
    width: "3px",
    borderRadius: "57px",
    margin: "3px 0px",
  },
}));

const DottedLine = ({ count, currentStep }) => {
  const classes = useStyles();
  console.log({ count, currentStep });
  return (
    <Box className={classes.dottedBox}>
      <Box
        className={currentStep >= count + 1 ? classes.dot : classes.inActiveDot}
      ></Box>
      <Box
        className={currentStep >= count + 1 ? classes.dot : classes.inActiveDot}
      ></Box>

      <Box
        className={currentStep >= count + 1 ? classes.dot : classes.inActiveDot}
      ></Box>

      <Box
        className={currentStep >= count + 1 ? classes.dot : classes.inActiveDot}
      ></Box>

      <Box
        className={currentStep >= count + 1 ? classes.dot : classes.inActiveDot}
      ></Box>

      <Box
        className={currentStep >= count + 1 ? classes.dot : classes.inActiveDot}
      ></Box>

      <Box
        className={currentStep >= count + 1 ? classes.dot : classes.inActiveDot}
      ></Box>

      <Box
        className={currentStep >= count + 1 ? classes.dot : classes.inActiveDot}
      ></Box>

      <Box
        className={currentStep >= count + 1 ? classes.dot : classes.inActiveDot}
      ></Box>
    </Box>
  );
};

export default DottedLine;
